// src/components/ProtectedLayout.js
import React, { useContext } from "react";
import TopNav from "../Navbar";
import { AuthContext } from "../AuthContext";

export default function ProtectedLayout({ children }) {
  const { hydrated, offline } = useContext(AuthContext);

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      {hydrated ? <TopNav /> : <div className="h-16" />}
      {offline}
      <main className="flex-1 p-4">{children}</main>
      <footer className="bg-blue-900 text-white text-center p-3 text-xs">
        © {new Date().getFullYear()} WECARE INDIA. All rights reserved.
      </footer>
    </div>
  );
}
